import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';

import classes from './classes.module.scss';
import Thumbnail from './Thumbnail';
import UploadModal from 'app/components/Uploads/UploadModal';
import useMomentReplaceUploadForm from 'app/hooks/useMomentReplaceUploadForm';

const MomentCell = props => {
  const {
    data,
    colDef,
    onImagesClick,
    showUpload,
    showUploadLabel,
    onUploadComplete,
    moment
  } = props;

  const {
    formIsOpen,
    onAdd,
    onFormClose,
    onFormSubmit
  } = useMomentReplaceUploadForm({
    onUploadComplete,
    moment
  });

  let thumbnail = null;
  if (colDef.thumbnail) {
    thumbnail = <Thumbnail data={data} colDef={colDef} lastUpdate={moment.uploaded} />;
  }

  let uploadIcon = null;
  let uploadModal = null;
  if (showUpload) {
    let uploadLabel = null;
    if (showUploadLabel) {
      uploadLabel = <span className={classes.gridIconLabel}>UPLOAD</span>;
    }

    uploadIcon = (
      <span className={classes.thumbnailLink} onClick={onAdd}>
	<AddIcon className={classes.gridIcon} />
	{uploadLabel}
      </span>
    );

    uploadModal = (
      <UploadModal
        isOpen={formIsOpen}
        onClose={onFormClose}
	onFormSubmit={onFormSubmit}
      />
    );
  }

  return (
    <div className={classes.thumbnailCell}>
      {thumbnail}
      {uploadIcon}
      {uploadModal}
    </div>
  );
}

export default MomentCell;
